export const GET_RATINGS_BY_VENUE_OWNER_ID = 'GET_RATINGS_BY_VENUE_OWNER_ID';
export const GET_RATINGS_BY_VENUE_OWNER_ID_SUCCESS = 'GET_RATINGS_BY_VENUE_OWNER_ID_SUCCESS';
export const GET_RATINGS_BY_VENUE_OWNER_ID_FAILED = 'GET_RATINGS_BY_VENUE_OWNER_ID_FAILED';
export const CREATE_RATING = 'CREATE_RATING';
export const CREATE_RATING_SUCCESS = 'CREATE_RATING_SUCCESS';
export const CREATE_RATING_FAILED = 'CREATE_RATING_FAILED';
export const CREATE_RATING_REPLY = 'CREATE_RATING_REPLY';
export const CREATE_RATING_REPLY_SUCCESS = 'CREATE_RATING_REPLY_SUCCESS';
export const CREATE_RATING_REPLY_FAILED = 'CREATE_RATING_REPLY_FAILED';
